module.exports = "App.Collections.ContactPhoneNumbers = Backbone.Collection.extend({\n\n  model: App.Models.ContactPhoneNumber\n\n});\n"